
import React, { Component } from 'react';
import { Form, Button, ModalFooter, FormGroup, CustomInput, Input } from 'reactstrap';
import FormInput from './formInput';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import './index.css'

class DynamicForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            formData: this.props.data,
            submitted: false,
            formIsValid: false,
            showResponseModal: false,
        };
    }

    isValidHandler = (updatedValue, validation, type) => {
        let isValid = true;

        isValid = updatedValue && isValid;

        if (validation.min || validation.max) {
            isValid = (updatedValue >= validation.min && updatedValue <= validation.max) && isValid;
        }

        // if (validation.minYear) {
        //     isValid = (updatedValue.trim() > validation.minYear && updatedValue.trim() < (new Date().getFullYear())) && isValid;
        // }
        return isValid;
    }

    handleSubmit = (event, dispatch) => {
        const relationData = [];
        event.preventDefault();
        const formData = {};
        const updatedData = this.state.formData;

        this.setState({
            submitted: true
        })

        let formIsValid = true;
        for (let identifiers in updatedData) {
            formIsValid = updatedData[identifiers].valid && formIsValid;
        }
        const fd = {};

        if (formIsValid) {

            this.state.formData.map(function (element) {
                if (element.type === 'number') {
                    fd[element.key] = +element.value;
                }

                if (element.type !== 'number') {
                    fd[element.key] = element.value;
                }

                if (element.type === 'checkbox') {
                    fd[element.key] = element.value === '' || element.value === false || element.value === 'false' ? false : true;
                }
            });


            const data = {
                data: fd,
            }
            this.setState({ showResponseModal: true })
            this.props.action(data);
            this.props.toggle &&
                this.props.toggle();
        }
    };

    onClickReset = () => {
        const frm = document.getElementsByName('customForm')[0];
        frm.reset();
        const resettingValues = this.state.formData;
        for (let key in resettingValues) {
            resettingValues[key].value = '';
            if (resettingValues[key].validation.required === true) {
                resettingValues[key].valid = false;
            }
            this.setState({ formData: resettingValues });
        }
    }

    propsChanged = (event, identifier, type) => {
        const updatedData = this.state.formData;
        const updatedElement = updatedData[identifier];
        if (type != 'checkbox') {
            updatedElement.value = event.target.value
        } else {
            updatedElement.value = event.target.checked
        }
        updatedElement.valid = this.isValidHandler(updatedElement.value, updatedElement.validation, type)
        updatedData[identifier] = updatedElement;

        this.setState({ formData: updatedData });
    };

    render() {
        return (
            <div>
                <Form name="customForm" onSubmit={this.handleSubmit} >
                    {/* {
                        this.props.dobError &&
                        <p className = "text-right text-danger">Date should be greater than 1900 and less than 2018</p>
                    } */}

                    {
                        this.state.formData.map(
                            (formElement, id) => (
                                <FormGroup key={id}
                                    className={"d-flex flex-row flex-wrap justify-content-center col-12 pl-3 form-check form-check-inline  "}>
                                    <FormInput
                                        key={id}
                                        type={formElement.type}
                                        name={formElement.elementConfig.name}
                                        id={formElement.elementConfig.name}
                                        placeholder={formElement.elementConfig.placeholder}
                                        value={formElement.value}
                                        label={formElement.elementConfig.label}
                                        invalid={!formElement.valid}
                                        shouldValidate={formElement.validation}
                                        changed={(event) => this.propsChanged(event, id, formElement.type)}
                                        submitted={this.state.submitted}
                                        error={formElement.validation.message}
                                        required={formElement.validation.required}
                                        data={formElement.elementConfig}
                                        formName={this.props.formName}
                                        selects={this.props.selects}
                                        selectKey={this.props.selectKey}
                                        min={formElement.min !== undefined ? formElement.min : 0}
                                        max={formElement.max !== undefined ? formElement.max : Infinity}
                                        accept={formElement.accept !==  undefined ? formElement.accept : ""}
                                        getDataFunc={formElement.getDataFunc !==  undefined ? (data) => formElement.getDataFunc(data) : () => console.log('no function passed to getDataFunc prop')}
                                    />
                                </FormGroup>
                            )
                        )
                    }

                    {/* {
                        this.props.formName === 'user-details' &&
                        <ModalFooter style={{ margin: "auto" }} >
                 
                            <Button color=" btn-sm text-white bg-secondary" onClick={this.props.cancel}><small> CANCEL</small></Button>
                            <button className="btn-red btn-sm " type="submit"><small>SAVE CHANGES</small></button>
                        </ModalFooter>
                    }

                    {
                        this.props.formName === 'nonSubmittableForm' &&
                        <ModalFooter style={{ margin: "auto" }} >
                            <Button style={{ marginRight: "auto" }}
                                color="secondary" onClick={this.onClickReset}>Reset</Button>
                            <Button color="secondary" type="submit" >Next</Button>
                        </ModalFooter>
                    }*/}

                    {
                        !this.props.noClose &&
                        <ModalFooter style={{ margin: "auto", padding:'0px' }} >
                            <button className="btn  btn-sm text-white b-0" style={{ backgroundColor: "rgb(55, 65, 75)" }} type="submit"><span className="">{this.props.footerFormSubmitButton[0]}</span></button>
                            <button type="button" className="btn btn-sm text-white b-0" style={{ backgroundColor: "rgb(55, 65, 75)" }} onClick={this.props.toggle}><span className="">{this.props.footerFormSubmitButton[1]}</span></button>
                        </ModalFooter>
                    }

                </Form>

            </div>
        )
    }

}



function mapStateToProps(state) {
    return {
        state
    }
}

const connectedForm = connect(mapStateToProps)(DynamicForm);
export default withRouter(connectedForm);


// WEBPACK FOOTER //
// ./src/_components/common/Form/index.jsx